import * as types from "../../actions/actionTypes";

const initialState = {
  filiereList: [],
  filiereSelected: {},
  filiereStringList: []
};

const updateFiliereStringList = filiereList => {
  let filiereStringList = [];

  filiereList.forEach(filiere => {
    if (filiere.defaultValue) {
      if (filiereStringList.indexOf(filiere.defaultValue) < 0)
        filiereStringList.push(filiere.defaultValue);
    }
    if (filiere.getCatConditionsList && filiere.getCatConditionsList.length) {
      filiere.getCatConditionsList.forEach(getCatCondition => {
        if (
          getCatCondition.categorie &&
          filiereStringList.indexOf(getCatCondition.categorie) < 0
        )
          filiereStringList.push(getCatCondition.categorie);
      });
    }
  });

  return filiereStringList;
};

const filiereReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FILIERE: {
      let filiereStringList = updateFiliereStringList([
        ...state.filiereList,
        action.filiere
      ]);
      return {
        ...state,
        filiereList: [...state.filiereList, action.filiere],
        filiereStringList
      };
    }
    case types.UPDATE_FILIERE_SELECTED: {
      let filieres = state.filiereList.slice();
      for (let i = 0; i < filieres.length; i++) {
        if (filieres[i].catSelected === state.filiereSelected.catSelected) {
          filieres.splice(i, 1);
          break;
        }
      }
      filieres.push(action.filiere);
      let filiereStringList = updateFiliereStringList(filieres);
      return { ...state, filiereList: filieres, filiereStringList };
    }
    case types.SET_FILIERELIST: {
      let filiereStringList = updateFiliereStringList(action.filiereList);

      return { ...state, filiereList: action.filiereList, filiereStringList };
    }
    case types.CLEAN_FILIERELIST:
      return {
        ...state,
        filiereList: [],
        filiereSelected: {},
        filiereStringList: []
      };
    case types.REMOVE_FILIERE: {
      let filieres = state.filiereList.slice();
      for (let i = 0; i < filieres.length; i++) {
        if (filieres[i].catSelected === action.filiereCatSelected) {
          filieres.splice(i, 1);
          break;
        }
      }
      return { ...state, filiereList: filieres };
    }
    case types.SELECT_FILIERE:
      return { ...state, filiereSelected: action.filiereSelected };
    default:
      return state;
  }
};

export default filiereReducer;



// WEBPACK FOOTER //
// ./src/reducers/pomui/filiereReducer.js